package com.eladfinish.bible.contest.screens.search.data

import com.eladfinish.bible.contest.network.DefaultApiResult
import com.eladfinish.bible.contest.screens.search.api.DateResult
import com.eladfinish.bible.contest.screens.search.api.NumberResult
import com.eladfinish.bible.contest.screens.search.api.RootResult
import com.eladfinish.bible.contest.screens.search.api.SearchGithubApi

interface SearchRepository {

    suspend fun getNumberResults(
        number: Int,
    ): DefaultApiResult<NumberResult>

    suspend fun getRootResults(
        root: String,
    ): DefaultApiResult<RootResult>

    /** [day] == null: the whole month. A 404 (ClientError) means no verse has this date. */
    suspend fun getDateResults(
        month: Int,
        day: Int?,
    ): DefaultApiResult<DateResult>
}

class SearchRepositoryImpl(
    private val searchGithubApi: SearchGithubApi,
) : SearchRepository {

    override suspend fun getNumberResults(
        number: Int,
    ): DefaultApiResult<NumberResult> =
        searchGithubApi.getNumberResults(
            number = number,
        )

    override suspend fun getRootResults(
        root: String,
    ): DefaultApiResult<RootResult> =
        searchGithubApi.getRootResults(
            root = root,
        )

    override suspend fun getDateResults(
        month: Int,
        day: Int?,
    ): DefaultApiResult<DateResult> =
        searchGithubApi.getDateResults(
            month = month,
            day = day,
        )
}
